import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CustomersQueryKeys } from "modules/CustomersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteCustomerPayload = {
  id: number;
};

export const useDeleteCustomerMutation = () =>
  useTypedMutation<DeleteCustomerPayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/customers/delete", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ id }) => {
      const customers = typedQueryClient.getQueryData(CustomersQueryKeys.list);
      if (!customers?.items.length) return;

      const customerIdx = customers.items.findIndex(customer => customer.id === id);
      if (customerIdx === -1) return;

      typedQueryClient.setQueryData(CustomersQueryKeys.list, {
        ...customers,
        items: customers.items.toSpliced(customerIdx, 1),
        nb_items: customers.nb_items - 1
      });
    }
  });
